import React from "react";
import { Navigate } from "react-router-dom";
import { MODULES_ENUM ,PERMISSIONS_ENUM} from "../utility/constants";
// // Profile
// import UserProfile from "../pages/Authentication/user-profile"

// // Pages Calendar
// import Calendar from "../pages/Calendar/index"

// //Email
// import EmailInbox from "../pages/Email/email-inbox"
// import EmailRead from "../pages/Email/email-read"
// import EmailCompose from "../pages/Email/email-compose"

// // Authentication related pages
// import Login from "../pages/Authentication/Login"
// import Logout from "../pages/Authentication/Logout"
// import Register from "../pages/Authentication/Register"
// import ForgetPwd from "../pages/Authentication/ForgetPassword"

// // Inner Authentication
// import Login1 from "../pages/AuthenticationInner/Login"
// import Register1 from "../pages/AuthenticationInner/Register"
// import Recoverpw from "../pages/AuthenticationInner/Recoverpw"
// import LockScreen from "../pages/AuthenticationInner/auth-lock-screen"

// // Dashboard
import Dashboard from "../pages/Dashboard/index";

//Items
import ForgotPassword from "../pages/Authentication/ForgotPassword";
import Login from "../pages/Authentication/Login";
import ResetPassword from "../pages/Authentication/ResetPassword";
import AddCategory from "../pages/Categories/AddCategory";
import CreateClient from "../pages/Client/CreateClient";
import EditClient from "../pages/Client/EditClient";
// import PastAgreements from "../pages/Client/PastAgreements";
import ViewClient from "../pages/Client/ViewClient";
import PastAgreements from "../pages/Client/PastAgreements";
import AllClients from "../pages/Clients/AllClients";
import TableWithData from "../pages/DummyTable/TableWithData";
import ExpenseDetails from "../pages/Expenses/ExpenseDetails";
import Expenses from "../pages/Expenses/Expenses";
import AllInvoices from "../pages/Invoices/AllInvoices";
import AllPayments from "../pages/Invoices/AllPayments";
import PaymentDetails from "../pages/Invoices/PaymentDetails";
import ViewInvoice from "../pages/Invoices/ViewInvoice";
import AgreementItemsListing from "../pages/Items/AgreementItemsListing";
import AgreementItemView from "../pages/Items/AgreementItemView";
import AllItems from "../pages/Items/AllItems";
import CreateItems from "../pages/Items/CreateItems";
import EditItems from "../pages/Items/EditItems";
import ViewItems from "../pages/Items/ViewItems";
import Allorders from "../pages/Orders/Allorders";
import Createorder from "../pages/Orders/Createorder";
import OrderDetails from "../pages/Orders/OrderDetails";
import OrderEstimates from "../pages/Orders/OrderEstimates";
import PurchaseOrderDetails from "../pages/Orders/PurchaseOrderDetails";
import PurchaseOrderTrail from "../pages/Orders/PurchaseOrderTrail";
import Quotations from "../pages/Orders/Quotations";
import ViewEstimate from "../pages/Orders/ViewEstimate";
import ViewPurchaseOrder from "../pages/Orders/ViewPurchaseOrder";
import ByItemPRPO from "../pages/Reports/ByItemPRPO";
import ByPRPO from "../pages/Reports/ByPRPO";
import AllRequisition from "../pages/Requisition/AllRequisition";
import CreateRequisition from "../pages/Requisition/CreateRequisition";
import PurchaseRequisitionTrail from "../pages/Requisition/PurchaseRequisitionTrail";
import ViewPurchaseRequisition from "../pages/Requisition/ViewPurchaseRequisition";
import UserProfile from "../pages/Users/Profile";
import RoleDetails from "../pages/Users/RoleDetails";
import RolesPermissions from "../pages/Users/RolesPermissions";
import Users from "../pages/Users/Users";
import Branches from "../pages/Warehouses-Branches/Branches";
import Warehouses from "../pages/Warehouses-Branches/Warehouses";
import ClientUser from "../pages/Client/ClientUsers";
import ByItemSummary from "../pages/Reports/ByItemSummary";


//Charts
// import ChartsAppex from "../pages/Charts/charts-appex";
// import ChartsJs from "../pages/Charts/charts-chartjs";
// import ChartsKnob from "../pages/Charts/charts-knob";
// import ChartsC3 from "../pages/Charts/charts-c3";
// import ChartsSparkLine from "../pages/Charts/charts-sparkline";

// // Maps
// import MapsGoogle from "../pages/Maps/MapsGoogle"
// import MapsVector from "../pages/Maps/MapsVector"

// //Icons
// import IconMaterialdesign from "../pages/Icons/IconMaterialdesign"
// import Iconion from "../pages/Icons/Iconion"
// import IconFontawesome from "../pages/Icons/IconFontawesome"
// import IconThemify from "../pages/Icons/IconThemify"
// import IconDripicons from "../pages/Icons/IconDripicons"
// import IconTypicons from "../pages/Icons/IconTypicons"

// //Tables
// import BasicTables from "../pages/Tables/BasicTables"
// import DatatableTables from "../pages/Tables/DatatableTables"
// import ResponsiveTables from "../pages/Tables/ResponsiveTables"
// import EditableTables from "../pages/Tables/EditableTables"

// // Forms
// import FormElements from "../pages/Forms/FormElements"
// import FormAdvanced from "../pages/Forms/FormAdvanced"
// import FormEditors from "../pages/Forms/FormEditors"
// import FormValidations from "../pages/Forms/FormValidations"
// import FormUpload from "../pages/Forms/FormUpload"
// import FormXeditable from "../pages/Forms/FormXeditable"

// //Ui
// import UiAlert from "../pages/Ui/UiAlert"
// import UiButtons from "../pages/Ui/UiButtons"
// import UiBadge from "../pages/Ui/UiBadge"
// import UiCards from "../pages/Ui/UiCards"
// import UiCarousel from "../pages/Ui/UiCarousel"
// import UiDropdown from "../pages/Ui/UiDropdown"
// import UiGrid from "../pages/Ui/UiGrid"
// import UiImages from "../pages/Ui/UiImages"
// import UiLightbox from "../pages/Ui/UiLightbox"
// import UiModal from "../pages/Ui/UiModal"
// import UiPagination from "../pages/Ui/UiPagination"
// import UiPopoverTooltips from "../pages/Ui/UiPopoverTooltips"
// import UiProgressbar from "../pages/Ui/UiProgressbar"
// import UiTabsAccordions from "../pages/Ui/UiTabsAccordions"
// import UiTypography from "../pages/Ui/UiTypography"
// import UiVideo from "../pages/Ui/UiVideo"
// import UiSessionTimeout from "../pages/Ui/UiSessionTimeout"
// import UiRangeSlider from "../pages/Ui/UiRangeSlider"

// //Extra Pages
// import PagesTimeline from "../pages/Extra Pages/pages-timeline";
// import PagesInvoice from "../pages/Extra Pages/pages-invoice";
// import PagesDirectory from "../pages/Extra Pages/pages-directory";
// import PagesBlank from "../pages/Extra Pages/pages-blank";
// import Pages404 from "../pages/Extra Pages/pages-404";
// import Pages500 from "../pages/Extra Pages/pages-500";
// import UiUtilities from "pages/Ui/UiUtilities"
// import UiColors from "pages/Ui/UiColors"
// import UiOffcanvas from "pages/Ui/UiOffcanvas"
// import Chat from "pages/Chat/Chat";
// import Kanban from "pages/Kanban"

const userRoutes = [
  { path: "/create-item", component: <CreateItems />,module:MODULES_ENUM.ITEMS,operations:[PERMISSIONS_ENUM.CREATE]},
  { path: "/edit-item/:id", component: <EditItems />,module:MODULES_ENUM.ITEMS,operations:[PERMISSIONS_ENUM.UPDATE] },
  { path: "/client/add", component: <CreateClient />,module:MODULES_ENUM.CLIENTS,operations:[PERMISSIONS_ENUM.CREATE] },
  { path: "/items", component: <AllItems />,module:MODULES_ENUM.ITEMS,operations:[PERMISSIONS_ENUM.READ] },
  { path: "/view-item/:id", component: <ViewItems />,module:MODULES_ENUM.ITEMS,operations:[PERMISSIONS_ENUM.READ] },
  { path: "/clients", component: <AllClients />,module:MODULES_ENUM.CLIENTS,operations:[PERMISSIONS_ENUM.READ] },
  { path: "/categories", component: <AddCategory />,module:MODULES_ENUM.CATEGORIES,operations:[PERMISSIONS_ENUM.CREATE] },
  { path: "/dashboard", component: <Dashboard />,module:MODULES_ENUM.DASHBOARD,operations:[PERMISSIONS_ENUM.READ] },
  { path: "/quotations", component: <Quotations /> },
  { path: "/orders", component: <Allorders />,module:MODULES_ENUM.ORDERS,operations:[PERMISSIONS_ENUM.READ] },
  { path: "/purchase-orders", component: <ViewPurchaseOrder /> },
  { path: "/ongoing-orders", component: <Allorders />,module:MODULES_ENUM.ORDERS,operations:[PERMISSIONS_ENUM.READ] },
  { path: "/create-order", component: <Createorder />,module:MODULES_ENUM.ORDERS,operations:[PERMISSIONS_ENUM.CREATE] },
  { path: "/purchase-orders/copy/:id", component: <Createorder />},
  { path: "/purchase-orders/:id/edit", component: <Createorder /> },
  { path: "/purchase-orders/:id", component: <PurchaseOrderDetails /> },
  { path: "/purchase-orders/:id/trail", component: <PurchaseOrderTrail /> },
  { path: "/purchase-orders/:id/:version/:auditId", component: <PurchaseOrderDetails /> },
  { path: "/client/:id", component: <ViewClient />,module:MODULES_ENUM.CLIENTS,operations:[PERMISSIONS_ENUM.READ] },
  { path: "/client/:clientId/agreements", component: <PastAgreements /> },
  { path: "/invoices", component: <AllInvoices />,module:MODULES_ENUM.INVOICES,operations:[PERMISSIONS_ENUM.READ] },
  { path: "/payments", component: <AllPayments />,module:MODULES_ENUM.PAYMENTS,operations:[PERMISSIONS_ENUM.READ] },
  { path: "/payment/:id", component: <PaymentDetails />,module:MODULES_ENUM.INVOICES,operations:[PERMISSIONS_ENUM.READ] },
  { path: "/view-invoice/:id", component: <ViewInvoice />,module:MODULES_ENUM.INVOICES,operations:[PERMISSIONS_ENUM.READ] },
  { path: "/order/:id", component: <OrderDetails />,module:MODULES_ENUM.INVOICES,operations:[PERMISSIONS_ENUM.READ] },
  { path: "/users", component: <Users />,module:MODULES_ENUM.USERS,operations:[PERMISSIONS_ENUM.READ] },
  { path: "/estimates", component: <OrderEstimates /> },
  { path: "/expenses", component: <Expenses /> },
  { path: "/view-estimate/:id", component: <ViewEstimate /> },
  { path: "/agreement-items", component: <AgreementItemsListing /> },
  { path: "/view-agreement-item/:id", component: <AgreementItemView /> },
  { path: "/client/edit/:id", component: <EditClient />,module:MODULES_ENUM.CLIENTS,operations:[PERMISSIONS_ENUM.UPDATE] },
  { path: "/view-expense/:id", component: <ExpenseDetails /> },
  { path: "/warehouses", component: <Warehouses />, module: MODULES_ENUM.WAREHOUSES,operations: [PERMISSIONS_ENUM.READ] },
  { path: "/branches", component: <Branches />, module: MODULES_ENUM.BRANCHES, operations: [PERMISSIONS_ENUM.READ] },
  { path: "/purchase-requisitions", component: <AllRequisition />,module:MODULES_ENUM.PURCHASE_REQUISITIONS,operations:[PERMISSIONS_ENUM.READ] },
  { path: "/create-requisition", component: <CreateRequisition />,module:MODULES_ENUM.PURCHASE_REQUISITIONS,operations:[PERMISSIONS_ENUM.CREATE] },
  { path: "/purchase-requisitions/:id", component: <ViewPurchaseRequisition />,module:MODULES_ENUM.PURCHASE_REQUISITIONS,operations:[PERMISSIONS_ENUM.READ] },
  { path: "/purchase-requisitions/:id/trail", component: <PurchaseRequisitionTrail />,module:MODULES_ENUM.PURCHASE_REQUISITIONS,operations:[PERMISSIONS_ENUM.READ] },
  { path: "/purchase-requisitions/:id/:version/:auditId", component: <ViewPurchaseRequisition />,module:MODULES_ENUM.PURCHASE_REQUISITIONS,operations:[PERMISSIONS_ENUM.READ] },
  { path: "/purchase-requisitions/:id/edit", component: <CreateRequisition />,module:MODULES_ENUM.PURCHASE_REQUISITIONS,operations:[PERMISSIONS_ENUM.UPDATE] },
  { path: "/purchase-requisitions/:copyId/copy", component: <CreateRequisition /> },
  { path: "/table", component: <TableWithData /> },
  { path: "/roles-permissions", component: <RolesPermissions /> ,module:MODULES_ENUM.ROLES,operations:[PERMISSIONS_ENUM.READ]},
  { path: "/roles/:role/:action", component: <RoleDetails /> },
  { path: "/reports/by-pr", component: <ByPRPO reportType="PR" userType="admin"/>,module:MODULES_ENUM.ADMIN_REPORTS,operations:[PERMISSIONS_ENUM.READ]},
  { path: "/reports/by-po", component: <ByPRPO reportType="PO" userType="admin"/>,module:MODULES_ENUM.ADMIN_REPORTS,operations:[PERMISSIONS_ENUM.READ]},
  { path: "/reports/customer-pr", component: <ByPRPO reportType="PR" userType="client"/>,module:MODULES_ENUM.CLIENT_REPORTS,operations:[PERMISSIONS_ENUM.READ]},
  { path: "/reports/customer-po", component: <ByPRPO reportType="PO" userType="client"/>,module:MODULES_ENUM.CLIENT_REPORTS,operations:[PERMISSIONS_ENUM.READ]},
  { path: "/reports/item", component: <ByItemSummary reportType="PR" userType="admin"/>,module:MODULES_ENUM.ADMIN_REPORTS,operations:[PERMISSIONS_ENUM.READ]},
  { path: "/reports/item/by-po", component: <ByItemPRPO reportType="PO" userType="admin"/>,module:MODULES_ENUM.ADMIN_REPORTS,operations:[PERMISSIONS_ENUM.READ]},
  { path: "/reports/items", component: <ByItemSummary reportType="PR" userType="client"/>,module:MODULES_ENUM.CLIENT_REPORTS,operations:[PERMISSIONS_ENUM.READ]},
  { path: "/reports/item/customer-po", component: <ByItemPRPO reportType="PO" userType="client"/>,module:MODULES_ENUM.CLIENT_REPORTS,operations:[PERMISSIONS_ENUM.READ]},
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  {path:"/client-users/:clientId",component: <ClientUser title="Admin"/>,module:MODULES_ENUM.CLIENTUSERS,operations:[PERMISSIONS_ENUM.READ]},

  // // //calendar
  // { path: "/calendar", component: <Calendar /> },

  // { path: "/chat", component: <Chat /> },
  // { path: "/kanbanboard", component: <Kanban /> },

  // // //profile
  { path: "/profile", component: <UserProfile /> },

  { path: "*", component: <Navigate to="/dashboard" /> },
  // // //Email
  // { path: "/email-inbox", component: <EmailInbox /> },
  // { path: "/email-read", component: <EmailRead /> },
  // { path: "/email-compose", component: <EmailCompose /> },

  // // //Charts
  // { path: "/apex-charts", component: <ChartsAppex /> },
  // { path: "/charts-chartjs", component: <ChartsJs /> },
  // { path: "/charts-knob", component: <ChartsKnob /> },
  // { path: "/charts-c3", component: <ChartsC3 /> },
  // { path: "/sparkline-charts", component: <ChartsSparkLine /> },

  // // // Icons
  // { path: "/icons-materialdesign", component: <IconMaterialdesign /> },
  // { path: "/icons-ion", component: <Iconion /> },
  // { path: "/icons-fontawesome", component: <IconFontawesome /> },
  // { path: "/icons-themify", component: <IconThemify /> },
  // { path: "/icons-dripicons", component: <IconDripicons /> },
  // { path: "/icons-typicons", component: <IconTypicons /> },

  // // // Tables
  // { path: "/tables-basic", component: <BasicTables /> },
  // { path: "/tables-datatable", component: <DatatableTables /> },
  // { path: "/tables-responsive", component: <ResponsiveTables /> },
  // { path: "/tables-editable", component: <EditableTables /> },

  // // // Maps
  // { path: "/maps-google", component: <MapsGoogle /> },
  // { path: "/maps-vector", component: <MapsVector /> },

  // // // Forms
  // { path: "/form-elements", component: <FormElements /> },
  // { path: "/form-advanced", component: <FormAdvanced /> },
  // { path: "/form-editors", component: <FormEditors /> },
  // { path: "/form-uploads", component: <FormUpload /> },
  // { path: "/form-validation", component: <FormValidations /> },
  // { path: "/form-xeditable", component: <FormXeditable /> },

  // // // Ui
  // { path: "/ui-alerts", component: <UiAlert /> },
  // { path: "/ui-buttons", component: <UiButtons /> },
  // { path: "/ui-badge", component: <UiBadge /> },
  // { path: "/ui-cards", component: <UiCards /> },
  // { path: "/ui-carousel", component: <UiCarousel /> },
  // { path: "/ui-dropdowns", component: <UiDropdown /> },
  // { path: "/ui-grid", component: <UiGrid /> },
  // { path: "/ui-images", component: <UiImages /> },
  // { path: "/ui-lightbox", component: <UiLightbox /> },
  // { path: "/ui-modals", component: <UiModal /> },
  // { path: "/ui-pagination", component: <UiPagination /> },
  // { path: "/ui-popover-tooltip", component: <UiPopoverTooltips /> },
  // { path: "/ui-progressbars", component: <UiProgressbar /> },
  // { path: "/ui-tabs-accordions", component: <UiTabsAccordions /> },
  // { path: "/ui-typography", component: <UiTypography /> },
  // { path: "/ui-video", component: <UiVideo /> },
  // { path: "/ui-session-timeout", component: <UiSessionTimeout /> },
  // { path: "/ui-rangeslider", component: <UiRangeSlider /> },
  // { path: "/ui-utilities", component: <UiUtilities /> },
  // { path: "/ui-colors", component: <UiColors /> },
  // { path: "/ui-offcanvas", component: <UiOffcanvas /> },

  // // //Extra Pages
  // { path: "/pages-timeline", component: <PagesTimeline /> },
  // { path: "/pages-invoice", component: <PagesInvoice /> },
  // { path: "/pages-directory", component: <PagesDirectory /> },
  // { path: "/pages-blank", component: <PagesBlank /> },
];

const authRoutes = [
  // { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgotPassword /> },
  { path: "/reset-password/:token", component: <ResetPassword /> },
  // { path: "/register", component: <Register /> },

  // { path: "/pages-404", component: <Pages404 /> },
  // { path: "/pages-500", component: <Pages500 /> },

  // // Authentication Inner
  // { path: "/pages-login", component: <Login1 /> },
  // { path: "/pages-register", component: <Register1 /> },
  // { path: "/page-recoverpw", component: <Recoverpw /> },
  // { path: "/auth-lock-screen", component: <LockScreen /> },
];

export { authRoutes, userRoutes };

